export default class Menu {


	// Constructor
	constructor(asscroll) {

		this.element = document.getElementById('menu');

		this.asscroll = asscroll;
		this.asscrollCurrentPos = 0;
		this.asscrollElement = (asscroll) ? asscroll.scrollElements : null;

		this.buttonClose = this.element.querySelector('.header-menu--bg');
		this.buttonMenu = document.querySelector('.header--menu-button');
		this.buttonMenuText = this.buttonMenu.querySelector('span');

		let i, ii, l, ll, selectors, items;

		this.itemsMenu = [];
		selectors = [
			'a',
			'button'
		];
		for (i=0, l=selectors.length; i<l; i++) {
			items = Array.prototype.slice.call(this.element.querySelectorAll(selectors[i]), 0);
			for (ii=0, ll=items.length; ii<ll; ii++) {
				this.itemsMenu.push(items[ii]);
			}
		}

		this.itemsPage = [];
		selectors = [
			'#main a',
			'#main button',
			'#main input',
			'#main select',
			'#main textarea',
			'#footer a'
		];
		for (i=0, l=selectors.length; i<l; i++) {
			items = Array.prototype.slice.call(document.querySelectorAll(selectors[i]), 0);
			for (ii=0, ll=items.length; ii<ll; ii++) {
				this.itemsPage.push(items[ii]);
			}
		}

		this.buttonsBack = Array.prototype.slice.call(this.element.querySelectorAll('.header-menu--back'), 0);
		this.buttonsSection = Array.prototype.slice.call(this.element.querySelectorAll('.header-menu--section'), 0);
		this.panelMenu = this.element.querySelector('.header-menu--menu');
		this.panelMenus = Array.prototype.slice.call(this.element.querySelectorAll('.header-menu--submenu'), 0)
		this.panel = this.element.querySelector('.header-menu--panel');
		this.title = this.element.querySelector('.header-menu--title');

		this.current = -1;
		this.colors = [];
		for (i=0, l=this.buttonsSection.length; i<l; i++) {
			this.colors.push(this.buttonsSection[i].getAttribute('data-color'));
		}

		this.modal = null;
		this.resetTimer = null;

		this.reset = this.reset.bind(this);
		this.sectionClicked = this.sectionClicked.bind(this);
		this.sectionOut = this.sectionOut.bind(this);
		this.sectionOver = this.sectionOver.bind(this);
		this.triggerClicked = this.triggerClicked.bind(this);

		this.handlePanelKeyboardNavigation = this.handlePanelKeyboardNavigation.bind(this)
	}

	// Public Methods
	destroy() {
		this.disable();
		delete this.asscroll;
		delete this.asscrollCurrentPos;
		delete this.asscrollElement;
		delete this.buttonMenu;
		delete this.buttonMenuText;
		delete this.buttonsBack;
		delete this.buttonsSection;
		delete this.colors;
		delete this.current;
		delete this.element;
		delete this.itemsMenu;
		delete this.itemsPage;
		delete this.modal;
		delete this.panel;
		delete this.panelMenu;
		delete this.panelMenus;
		delete this.resetTimer;
		delete this.title;
	}
	enable() {

		document.body.classList.add('menu-ready');

		let i, l;
		this.buttonClose.addEventListener('click', this.triggerClicked);
		this.buttonMenu.addEventListener('click', this.triggerClicked);
		for (i=0, l=this.buttonsBack.length; i<l; i++) {
			this.buttonsBack[i].addEventListener('click', this.sectionClicked);
		}
		for (i=0, l=this.buttonsSection.length; i<l; i++) {
			if (this.buttonsSection[i].tagName === 'BUTTON') {
				this.buttonsSection[i].addEventListener('click', this.sectionClicked);
			}
			this.buttonsSection[i].addEventListener('mouseout', this.sectionOut);
			this.buttonsSection[i].addEventListener('mouseover', this.sectionOver);
		}
		this.updateState();
	}
	disable() {
		let i, l;
		this.itemsMenu.forEach(function(item) {
			item.removeAttribute('aria-hidden');
			item.removeAttribute('tabindex');
		});
		this.itemsPage.forEach(function(item) {
			item.removeAttribute('aria-hidden');
			item.removeAttribute('tabindex');
		});
		for (i=0, l=this.buttonsBack.length; i<l; i++) {
			this.buttonsBack[i].removeEventListener('click', this.sectionClicked);
		}
		for (i=0, l=this.buttonsSection.length; i<l; i++) {
			if (this.buttonsSection[i].tagName === 'BUTTON') {
				this.buttonsSection[i].removeEventListener('click', this.sectionClicked);
			}
			this.buttonsSection[i].removeEventListener('mouseout', this.sectionOut);
			this.buttonsSection[i].removeEventListener('mouseover', this.sectionOver);
		}
		this.buttonClose.removeEventListener('click', this.triggerClicked);
		this.buttonMenu.removeEventListener('click', this.triggerClicked);
	}


	// Hide & Show
	show() {

		clearTimeout(this.resetTimer);

		if (this.modal !== null) {
			this.modal.hide();
			this.modal = null;
		}

		document.body.classList.add('show-menu');
		this.updateState();

		if (this.asscroll) {
			this.asscrollCurrentPos = this.asscroll.currentPos;
		}
		this.showMenu(-1, true);

		window.addEventListener('keyup', this.handlePanelKeyboardNavigation)
	}
	hide() {
		clearTimeout(this.resetTimer);

		document.body.classList.remove('show-menu');
		this.updateState();

		if (this.asscroll) {
			this.asscroll.disable();
			this.asscroll.currentPos = this.asscrollCurrentPos;
			this.asscroll.enable({ newScrollElements: this.asscrollElement });
		}

		this.resetTimer = setTimeout(this.reset, 1100);

		window.removeEventListener('keyup', this.handlePanelKeyboardNavigation)
	}
	showModal(modal) {
		document.body.classList.remove('show-menu');
		this.modal = modal;
		this.updateState();
	}
	hideModal() {
		document.body.classList.remove('show-menu');
		this.modal = null;
		this.updateState();
	}



	// Event Handlers
	reset() {
		this.showMenu(-1, false);
	}
	sectionClicked(event) {
		event.preventDefault();
		const index = this.buttonsSection.indexOf(event.currentTarget);
		this.showMenu(index, true);
	}
	sectionOut() {
		if (this.current !== -1) {
			return;
		}
		this.setColor(null);
	}
	sectionOver(event) {
		if (this.current !== -1) {
			return;
		}
		const index = this.buttonsSection.indexOf(event.currentTarget);
		this.setColor(this.colors[index]);
	}
	triggerClicked(event) {
		event.preventDefault();
		if (document.body.classList.contains('show-menu')) {
			this.hide();
		} else {
			this.show();
		}
	}


	// Helpers
	setColor(color) {
		if (color === null) {
			this.panel.removeAttribute('style');
			this.title.removeAttribute('style');
		} else {
			this.panel.style.backgroundColor = color;
			this.title.style.backgroundColor = color;
		}
	}
	showMenu(index, updateScroll) {
		this.current = index;

		let i, l;
		let panel = this.panelMenu;

		if (index === -1) {
			this.panelMenu.setAttribute('aria-hidden', 'false');
			this.panelMenu.classList.add('is-active');
			this.setColor(null);
		} else {
			this.panelMenu.setAttribute('aria-hidden', 'true');
			this.panelMenu.classList.remove('is-active');
			this.setColor(this.colors[index]);
		}

		for (i=0, l=this.panelMenus.length; i<l; i++) {
			if (i === index) {
				panel = this.panelMenus[i];
				this.panelMenus[i].setAttribute('aria-hidden', 'false');
				this.panelMenus[i].setAttribute('tabindex', '');
				this.panelMenus[i].classList.add('is-active');
			} else {
				this.panelMenus[i].setAttribute('aria-hidden', 'true');
				this.panelMenus[i].setAttribute('tabindex', '-1');
				this.panelMenus[i].classList.remove('is-active');
			}
		}
		for (i=0, l=this.buttonsSection.length; i<l; i++) {
			if (this.buttonsSection[i].tageName === 'BUTTON') {
				if (i === index) {
					this.buttonsSection[i].setAttribute('aria-expanded', 'true');
				} else {
					this.buttonsSection[i].setAttribute('aria-expanded', 'false');
				}
			}
		}

		if (updateScroll) {
			if (this.asscroll) {
				this.asscroll.disable();
				this.asscroll.enable({ newScrollElements: panel, reset: true });
			}
		}
	}
	updateState() {
		if (this.modal !== null) {
			this.element.setAttribute('aria-hidden', 'true');
			this.buttonMenu.setAttribute('aria-expanded', 'false');
			this.buttonMenuText.innerHTML = this.buttonMenu.getAttribute('data-text-show');
			this.itemsMenu.forEach(function(item) {
				item.setAttribute('aria-hidden', 'true');
				item.setAttribute('tabindex', '-1');
			});
			this.itemsPage.forEach(function(item) {
				item.setAttribute('aria-hidden', 'true');
				item.setAttribute('tabindex', '-1');
			});
			return;
		}
		if (document.body.classList.contains('show-menu')) {
			this.element.setAttribute('aria-hidden', 'false');
			this.buttonMenu.setAttribute('aria-expanded', 'true');
			this.buttonMenuText.innerHTML = this.buttonMenu.getAttribute('data-text-hide');
			this.itemsMenu.forEach(function(item) {
				item.removeAttribute('aria-hidden');
				item.removeAttribute('tabindex');
			});
			this.itemsPage.forEach(function(item) {
				item.setAttribute('aria-hidden', 'true');
				item.setAttribute('tabindex', '-1');
			});
		} else {
			this.element.setAttribute('aria-hidden', 'true');
			this.buttonMenu.setAttribute('aria-expanded', 'false');
			this.buttonMenuText.innerHTML = this.buttonMenu.getAttribute('data-text-show');
			this.itemsMenu.forEach(function(item) {
				item.setAttribute('aria-hidden', 'true');
				item.setAttribute('tabindex', '-1');
			});
			this.itemsPage.forEach(function(item) {
				item.removeAttribute('aria-hidden');
				item.removeAttribute('tabindex');
			});
		}
	}

	returnFocus() {
		if (this.returnFocusElement) {
			this.returnFocusElement.focus()
		}
	}

	handlePanelKeyboardNavigation(e) {

		// User hit escape. Close the panel
		if (e.keyCode == 27) {
			return this.hide()
		}

	  let focasables;
	  if (e.key == 'Tab') {

	  	let subMenu = this.panel.querySelector('.header-menu--submenu.is-active')
	  	let container = this.panel

	  	let resetFocus = false
	  	if (subMenu) {
	  		container = subMenu
	  		if (!this.activeSubmenu) {
	  			resetFocus = true
	  			this.activeSubmenu = subMenu
	  		}
	  	} else if (this.activeSubmenu) {
	  		resetFocus = true
	  		this.activeSubmenu = null
	  	}

	  	focasables = container.querySelectorAll("a, input, select, button");
	  	
	    if (focasables) {
	      const firstElem = focasables[0];
	      const lastElem = focasables[(focasables.length - 1)];

	      if (resetFocus) {
	      	e.preventDefault();
	      	firstElem.focus()
	      } 
	      // else if (e.target == firstElem && e.shiftKey) {
	      //   e.preventDefault();
	      //   lastElem.focus();
	      // } else if (e.target == lastElem && !e.shiftKey) {
	      //   e.preventDefault();
	      //   firstElem.focus();
	      // }
	    }
	  }
	}
}
